import gql from 'graphql-tag';

export const MUTATION_CANCEL_EQUIPMENT_COUNTING_JOURNAL = gql`
  mutation cancelEquipmentCountingJournal(
    $dto: DtoUpdateEquipmentCountingJournal!
  ) {
    updateEquipmentCountingJournal(dto: $dto) {
      id
      journalNum
      status
    }
  }
`;
